/**
 * Dropdown.js
 * Created by SMittapelli on 07/25/2020.
 */

import React from 'react';
import MotifDropdown from '@ey/motif-react-wrapper/Dropdown';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {dropdownOption} from '../shapes';
import {isNullOrUndefined} from '../../../util/utils';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import DropdownItem from './MotifDropdownItem';

function Dropdown(props) {
	const {
		ariaLabelledby,
		className,
		dropdownClass,
		portalClassName,
		closeOnOutsideClick,
		handleClickOutside,
		focusTrapActive,
		focusTrapPaused,
		handleOnClose,
		handleOnOpen,
		id,
		open,
		placement,
		trigger,
		usePortal = false,
		children,
		options
	} = props;

	// Backwards compatibility fix until all consumers adapted to new Motif version
	const _closeOnOutsideClick = !isNullOrUndefined(handleClickOutside)
		? !isNullOrUndefined(handleClickOutside)
		: closeOnOutsideClick;

	const _dropdownClassName = className || dropdownClass || portalClassName;

	// TODO Implement a default trigger with a MotifButton
	const dropdownTrigger = trigger;

	return (
		<StyledMotifDropdown
			ariaLabelledby={ariaLabelledby}
			className={_dropdownClassName ? _dropdownClassName : ''}
			closeOnOutsideClick={_closeOnOutsideClick}
			focusTrapActive={focusTrapActive}
			focusTrapPaused={focusTrapPaused}
			handleOnClose={handleOnClose}
			handleOnOpen={handleOnOpen}
			id={id ? id : ''}
			open={open}
			trigger={dropdownTrigger}
			usePortal={usePortal}
		>
			{children ? (
				children
			) : (
				<React.Fragment>
					{options?.length > 0 &&
						options.map((opt, idx) => {
							let className = opt.isDisabled ? 'dropdown-item-text-wrapper isRequired' : 'dropdown-item-text-wrapper';
							className += opt.isSelected ? ' selected' : '';

							const onClick = opt.onClick ? opt.onClick : (e) => opt.onClickCallback(e, opt);
							return (
								<DropdownItem indexItem={idx}>
									<section className={className} onClick={(e) => opt.onClick(e, opt)}>
										<EllipsesControl content={opt.label} tooltip={opt.label} noOfLines={1} />
										{opt.renderButtonPill ? opt.renderButtonPill(onClick) : ''}
									</section>
								</DropdownItem>
							);
						})}
				</React.Fragment>
			)}
		</StyledMotifDropdown>
	);
}

export default Dropdown;

Dropdown.propTypes = {
	open: PropTypes.bool,
	placement: PropTypes.string,
	handleClickOutside: PropTypes.func,
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	sideChildren: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	dropdownClass: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	ariaLabelledby: PropTypes.string,
	options: PropTypes.arrayOf(dropdownOption)
};

Dropdown.defaultProps = {
	sideChildren: []
};

const StyledMotifDropdown = styled(MotifDropdown)``;
